/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wd_RestrictedInputs */

const en_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restricted`)
};

const ar_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وصول مقيد`)
};

const bn_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রাইভেট`)
};

const de_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingeschränkt`)
};

const es_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restringido`)
};

const fr_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restreint`)
};

const pt_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restrito`)
};

const zh_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受限`)
};

const tr_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kısıtlı`)
};

const ru_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограничено`)
};

const pl_wd_restricted = /** @type {(inputs: Wd_RestrictedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograniczone`)
};

/**
* | output |
* | --- |
* | "Restricted" |
*
* @param {Wd_RestrictedInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const wd_restricted = /** @type {((inputs?: Wd_RestrictedInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wd_RestrictedInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_wd_restricted(inputs)
	if (locale === "bn") return bn_wd_restricted(inputs)
	if (locale === "de") return de_wd_restricted(inputs)
	if (locale === "es") return es_wd_restricted(inputs)
	if (locale === "fr") return fr_wd_restricted(inputs)
	if (locale === "pt") return pt_wd_restricted(inputs)
	if (locale === "zh") return zh_wd_restricted(inputs)
	if (locale === "tr") return tr_wd_restricted(inputs)
	if (locale === "ru") return ru_wd_restricted(inputs)
	if (locale === "pl") return pl_wd_restricted(inputs)
	return en_wd_restricted(inputs)
});